import { useAdminOrganizationControllerFindById } from "service";

const useOrganizationDetail = (organizationId: string) => {
  const { data, isLoading, isError, refetch } =
    useAdminOrganizationControllerFindById({
      pathParams: { id: organizationId },
    });

  return {
    organization: data?.data,
    isLoading,
    isError,
    refetch,
  };
};

export default useOrganizationDetail;
